import { render, staticRenderFns } from "./UpdateGupshupChannel.vue?vue&type=template&id=014a5856&scoped=true"
import script from "./UpdateGupshupChannel.vue?vue&type=script&lang=js"
export * from "./UpdateGupshupChannel.vue?vue&type=script&lang=js"
import style0 from "./UpdateGupshupChannel.vue?vue&type=style&index=0&id=014a5856&prod&lang=scss&scoped=true"
import style1 from "./UpdateGupshupChannel.vue?vue&type=style&index=1&id=014a5856&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014a5856",
  null
  
)

export default component.exports